import { useState } from "react";
import { IPropsInputField } from "./fieldPropertiesInterface";
import InputField from "./inputField";
import "./passwordField.scss";
import { UtilService } from "../../../services/UtilService";

function PasswordField({
  model,
  attr,
  value,
  label,
  onChange,
  required,
  autoFocus
}: IPropsInputField) {
  const [showKeyEnabled, setShowKeyEnabled] = useState(false);
  return (
    <InputField
        type={showKeyEnabled ? 'text' : 'password'}
        attr={attr}
        value={value}
        label={label}
        model={model}
        onChange={onChange}
        required={required}
        autoFocus={autoFocus}
        sufix={
          <button
            type="button"
            className="key-field-sufix input-group-text right h-100"
            onClick={() => { setShowKeyEnabled(!showKeyEnabled); }}
            tabIndex={-1}
            aria-label={showKeyEnabled ? "Ocultar contraseña" : "Mostrar contraseña"}
          >
            <i className={`eye-icon zmdi zmdi-eye${showKeyEnabled ? '' : '-off'} text-muted`} ></i>
          </button>
        }
    ></InputField>
  );
}

export default PasswordField;